import { Injectable } from '@angular/core';
import { Portal } from '@angular/cdk/portal';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppBarPortalsService {
  get searchPortal$() {
    return this.searchPortalSubject.asObservable();
  }

  private searchPortalSubject: BehaviorSubject<Portal<any>>;
  private contextActionsPortalSubject: BehaviorSubject<Portal<any>>;

  setSearchPortal(portal: Portal<any>) {
    this.searchPortalSubject.next(portal);
  }
  get contextActionsPortal$() {
    return this.contextActionsPortalSubject.asObservable();
  }

  setContextActionsPortal(portal: Portal<any>) {
    this.contextActionsPortalSubject.next(portal);
  }

  constructor() {
    this.searchPortalSubject = new BehaviorSubject(undefined);
    this.contextActionsPortalSubject = new BehaviorSubject(undefined);
  }
}
